import { useQuery } from "@tanstack/react-query";
import { getUsers } from "../services/get-users";
import { ConsentFormStatus } from "@/pages/users/types/user";
import { useRegionFilter } from "@/features/regions/hooks/use-region-filter";

export default function useUsers({
  page = 0,
  search = "",
  is_lead,
  product_id,
  hrc_status,
  mc_status,
}: {
  page: number;
  search?: string;
  is_lead?: boolean;
  product_id?: string;
  hrc_status?: ConsentFormStatus;
  mc_status?: ConsentFormStatus;
}) {
  const region = useRegionFilter();

  const { data, isLoading, error, isFetching, isSuccess } = useQuery({
    queryKey: [
      "users",
      {
        page,
        search,
        is_lead,
        product_id,
        hrc_status,
        mc_status,
        region,
      },
    ],
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 30, // 30 minutes
    queryFn: () =>
      getUsers({
        page,
        search,
        is_lead,
        product_id,
        hrc_status,
        mc_status,
        region,
      }),
  });

  return { data, isLoading, error, isFetching, isSuccess };
}

export function useQueryEnum<T extends string>(
  searchParams: URLSearchParams,
  key: string,
  allowedValues: readonly T[]
): T | undefined {
  const value = searchParams.get(key);
  return value && allowedValues.includes(value as T)
    ? (value as T)
    : undefined;
}
